import s from "../../../../@babel/runtime/helpers/esm/extends.js";
import d from "../../../../@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js";
import P from "../resolveComponentProps/resolveComponentProps.js";
import S from "../mergeSlotProps/mergeSlotProps.js";
import c from "../useForkRef/useForkRef.js";
import u from "../appendOwnerState/appendOwnerState.js";
const v = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
function C(o) {
  var r;
  const {
    elementType: p,
    externalSlotProps: n,
    ownerState: t,
    skipResolvingSlotProps: l = !1
  } = o, i = d(o, v), e = l ? {} : P(n, t), {
    props: m,
    internalRef: a
  } = S(s({}, i, {
    externalSlotProps: e
  })), f = c(a, e?.ref, (r = o.additionalProps) == null ? void 0 : r.ref);
  return u(p, s({}, m, {
    ref: f
  }), t);
}
export {
  C as default
};
